var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndicacaoP3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 91,
    viewBox: "0 0 93 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09985 10.86L11.1799 74.8C11.5799 80.32 14.4999 83.76 19.3399 84.28L74.9599 69.86C74.9599 69.86 80.2599 68.1 81.8799 62.4L88.0799 28.94C88.4399 24.24 84.7599 19.98 79.9199 19.46L13.5599 3.26003C8.69985 2.74003 4.45985 6.16003 4.09985 10.86Z",
    fill: "url(#paint0_linear_20693_23640)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.02 47.58L85.46 37.3C85.24 37.38 85.04 37.46 84.8 37.52C80.9 38.48 76.52 34.32 75 28.22C73.48 22.12 75.4 16.38 79.3 15.42C79.52 15.36 79.74 15.32 79.98 15.3L77.78 6.5L23.76 19.96L34 61.02L88.02 47.58Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22.4201L7.56 32.7001C7.78 32.6201 7.98 32.5401 8.22 32.4801C12.12 31.5201 16.5 35.6801 18.02 41.7801C19.54 47.8801 17.62 53.6201 13.72 54.5801C13.5 54.6401 13.28 54.6801 13.04 54.7001L15.24 63.5001L33.66 58.9201L23.42 17.8401L5 22.4201Z",
    fill: "#FF5AAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4217 49.531L49.3624 48.8723L53.9956 23.1996L58.0221 23.8665L53.4217 49.531ZM44.9104 39.6513C41.2753 40.5564 37.6429 38.6784 36.6563 34.7158C35.7675 31.1462 37.6864 27.5383 41.649 26.5518C45.3169 25.6386 48.9412 27.4838 49.9196 31.4136C50.8165 35.016 48.9058 38.6566 44.9104 39.6513ZM44.0952 36.2373C45.7981 35.8133 46.561 34.1279 46.137 32.4249C45.6723 30.5582 44.118 29.6236 42.546 30.015C40.8758 30.4308 40.0802 32.1244 40.5042 33.8273C40.9608 35.6613 42.556 36.6205 44.0952 36.2373ZM65.5967 45.9086C61.9615 46.8136 58.3291 44.9357 57.3507 41.0058C56.4538 37.4034 58.3727 33.7956 62.3353 32.809C66.0032 31.8958 69.6356 33.7737 70.614 37.7036C71.5109 41.306 69.5921 44.9138 65.5967 45.9086ZM64.7815 42.4945C66.4844 42.0705 67.2473 40.3851 66.8233 38.6822C66.3667 36.8482 64.8124 35.9136 63.2405 36.305C61.5375 36.729 60.7665 38.3816 61.1905 40.0846C61.6471 41.9185 63.2095 42.8859 64.7815 42.4945Z",
    fill: "#FF5AAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.6208 0.21167L83.7733 16.9437L81.9556 18.3917C79.4851 20.3597 78.2493 23.6653 79.0711 26.9386L79.0729 26.9456L79.0746 26.9526C79.8794 30.2134 82.5184 32.5526 85.65 33.1424L87.9381 33.5734L92.0588 50.3004L12.9991 69.9885L8.82421 53.168L10.543 51.7152C12.8897 49.7317 14.0403 46.5079 13.2478 43.3381C12.4531 40.1594 9.93041 37.8534 6.92678 37.1968L4.72841 36.7162L0.554932 19.9013L79.6208 0.21167ZM9.3249 25.1789L10.7191 30.796C15.3021 32.5551 18.9903 36.4553 20.272 41.5821C21.5556 46.7163 20.1163 51.8998 16.8878 55.5996L18.2807 61.2117L83.301 45.0198L81.9723 39.6262C77.2223 37.9386 73.3549 33.9846 72.0468 28.6941C70.7234 23.4122 72.2702 18.0957 75.6766 14.3784L74.339 8.98852L9.3249 25.1789Z",
    fill: "url(#paint1_linear_20693_23640)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3242 45.6441C32.3986 45.1272 34.4993 46.3899 35.0161 48.4643L35.1086 48.8356C35.1399 48.9608 35.1646 49.0862 35.183 49.2113C35.2254 49.3305 35.2624 49.4528 35.2936 49.5781L35.4786 50.3206C35.5099 50.4458 35.5346 50.5712 35.553 50.6963C35.5954 50.8155 35.6324 50.9378 35.6636 51.0631L35.8486 51.8056C35.8799 51.9308 35.9046 52.0562 35.923 52.1813C35.9654 52.3005 36.0024 52.4228 36.0336 52.5481L36.2186 53.2906C36.2499 53.4158 36.2746 53.5412 36.293 53.6663C36.3354 53.7855 36.3724 53.9078 36.4036 54.0331L36.4961 54.4043C37.013 56.4787 35.7503 58.5794 33.6759 59.0963C31.6015 59.6131 29.5008 58.3505 28.9839 56.276L28.8914 55.9048C28.8602 55.7795 28.8355 55.6541 28.817 55.529C28.7746 55.4099 28.7376 55.2876 28.7064 55.1623L28.5214 54.4198C28.4902 54.2945 28.4655 54.1691 28.447 54.044C28.4046 53.9249 28.3676 53.8026 28.3364 53.6773L28.1514 52.9348C28.1202 52.8095 28.0955 52.6841 28.077 52.559C28.0346 52.4399 27.9976 52.3176 27.9664 52.1923L27.7814 51.4498C27.7502 51.3245 27.7255 51.1991 27.707 51.074C27.6646 50.9549 27.6276 50.8326 27.5964 50.7073L27.5039 50.336C26.9871 48.2616 28.2497 46.1609 30.3242 45.6441Z",
    fill: "url(#paint2_linear_20693_23640)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2041 33.104C29.2785 32.5872 31.3792 33.8498 31.896 35.9243L31.9885 36.2955C32.0197 36.4208 32.0445 36.5462 32.0629 36.6713C32.1053 36.7904 32.1423 36.9127 32.1735 37.038L32.3585 37.7805C32.3897 37.9058 32.4145 38.0312 32.4329 38.1563C32.4753 38.2754 32.5123 38.3977 32.5435 38.523L32.7285 39.2655C32.7597 39.3908 32.7845 39.5162 32.8029 39.6413C32.8453 39.7604 32.8823 39.8827 32.9135 40.008L33.0985 40.7505C33.1297 40.8758 33.1545 41.0012 33.1729 41.1263C33.2153 41.2454 33.2523 41.3677 33.2835 41.493L33.376 41.8643C33.8929 43.9387 32.6302 46.0394 30.5558 46.5562C28.4813 47.0731 26.3807 45.8104 25.8638 43.736L25.7713 43.3647C25.7401 43.2395 25.7154 43.1141 25.6969 42.989C25.6545 42.8698 25.6175 42.7475 25.5863 42.6222L25.4013 41.8797C25.3701 41.7545 25.3454 41.6291 25.3269 41.504C25.2845 41.3848 25.2475 41.2625 25.2163 41.1372L25.0313 40.3947C25.0001 40.2695 24.9754 40.1441 24.9569 40.019C24.9145 39.8998 24.8775 39.7775 24.8463 39.6522L24.6613 38.9097C24.6301 38.7845 24.6054 38.6591 24.5869 38.534C24.5445 38.4148 24.5075 38.2925 24.4763 38.1672L24.3838 37.796C23.8669 35.7216 25.1296 33.6209 27.2041 33.104Z",
    fill: "url(#paint3_linear_20693_23640)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0839 20.564C26.1584 20.0471 28.259 21.3098 28.7759 23.3842L28.8684 23.7555C28.8996 23.8808 28.9243 24.0061 28.9428 24.1312C28.9852 24.2504 29.0222 24.3727 29.0534 24.498L29.2384 25.2405C29.2696 25.3658 29.2943 25.4911 29.3128 25.6162C29.3552 25.7354 29.3922 25.8577 29.4234 25.983L29.6084 26.7255C29.6396 26.8508 29.6643 26.9761 29.6828 27.1012C29.7252 27.2204 29.7622 27.3427 29.7934 27.468L29.9784 28.2105C30.0096 28.3358 30.0343 28.4611 30.0528 28.5862C30.0952 28.7054 30.1322 28.8277 30.1634 28.953L30.2559 29.3242C30.7728 31.3987 29.5101 33.4993 27.4357 34.0162C25.3612 34.5331 23.2606 33.2704 22.7437 31.196L22.6512 30.8247C22.62 30.6994 22.5953 30.5741 22.5768 30.4489C22.5344 30.3298 22.4974 30.2075 22.4662 30.0822L22.2812 29.3397C22.25 29.2144 22.2253 29.0891 22.2068 28.9639C22.1644 28.8448 22.1274 28.7225 22.0962 28.5972L21.9112 27.8547C21.88 27.7294 21.8553 27.6041 21.8368 27.4789C21.7944 27.3598 21.7574 27.2375 21.7262 27.1122L21.5412 26.3697C21.51 26.2444 21.4853 26.1191 21.4668 25.9939C21.4244 25.8748 21.3874 25.7525 21.3562 25.6272L21.2637 25.256C20.7468 23.1815 22.0095 21.0809 24.0839 20.564Z",
    fill: "url(#paint4_linear_20693_23640)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.122 29.9634C69.122 42.4832 58.9629 52.6464 46.4482 52.6464C33.9335 52.6464 23.7561 42.4832 23.7561 29.9634C23.7561 17.4436 33.9151 7.28052 46.4298 7.28052C58.9445 7.28052 69.122 17.4252 69.122 29.9634Z",
    fill: "url(#paint5_linear_20693_23640)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3399 90.1802C60.5399 91.0202 57.5799 89.4202 56.7599 86.6002L48.8599 59.9402L59.0199 56.9202L66.9199 83.5802C67.7599 86.4002 66.1599 89.3402 63.3399 90.1802Z",
    fill: "#079D56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2598 57.8001L50.1398 64.2601L47.5798 55.6401L57.7398 52.6201L59.2598 57.8001Z",
    fill: "#006B3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 6.3201C24.2 10.5401 16.08 25.4801 20.3 39.7001C24.52 53.9201 39.46 62.0201 53.68 57.8001C67.9 53.5801 76 38.6401 71.78 24.4201C67.56 10.2001 52.62 2.1001 38.4 6.3201ZM51.86 51.6601C41.04 54.8801 29.66 48.7001 26.44 37.8801C23.22 27.0601 29.4 15.6801 40.22 12.4601C51.04 9.24011 62.42 15.4201 65.64 26.2401C68.86 37.0601 62.68 48.4601 51.86 51.6601Z",
    fill: "#079D56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20693_23640",
    x1: 49.0222,
    y1: 30.1791,
    x2: 5.0079,
    y2: 74.1934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0739316,
    stopColor: "#EC8709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2075,
    stopColor: "#EF9910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3662,
    stopColor: "#F2A616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    stopColor: "#F4AE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20693_23640",
    x1: 7.90268,
    y1: 44.6576,
    x2: 84.7399,
    y2: 25.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20693_23640",
    x1: 29.4292,
    y1: 53.0081,
    x2: 34.5629,
    y2: 51.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20693_23640",
    x1: 26.3067,
    y1: 40.4668,
    x2: 31.4404,
    y2: 39.1887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20693_23640",
    x1: 23.1842,
    y1: 27.9255,
    x2: 28.3179,
    y2: 26.6474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20693_23640",
    x1: 46.439,
    y1: 52.6464,
    x2: 46.439,
    y2: 7.27691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006B3F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3265,
    stopColor: "#006D41",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#007547",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6485,
    stopColor: "#008351",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7728,
    stopColor: "#009760",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#00B073",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9864,
    stopColor: "#00CE89",
    stopOpacity: 0.9864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D38D"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndicacaoP3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indicacao_p3.afccc2c4e5d636d5ad6434c61b28cd41.svg";